import { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/macro";

const importMessages: Record<string, MessageDescriptor> = {
  "Budget mismatch": msg`Het budget kan afwijken van het eerder ingevulde budget i.v.m. kortingen en/of toeslagen.`,
};

export default importMessages;
